/* eslint-disable func-style */
import { useState, useCallback, useEffect } from 'react';
import { useMonitoringContext } from './MonitorContext.jsx';
import Messenger from '../../views/components/messenger.js';
import csrfToken from '../../util/csrfToken.js';

export function useSubscriber(eventName, initialStatus) {
  const {
    state: { isExpired },
  } = useMonitoringContext();
  const [status, setStatus] = useState(initialStatus);

  useEffect(() => {
    if (isExpired) {
      return;
    }

    let didUnsubscribe = false;
    const handleUpdate = (newStatus) => {
      if (didUnsubscribe) {
        return;
      }

      setStatus(newStatus);
    };

    Messenger.on(eventName, handleUpdate);
    return () => {
      didUnsubscribe = true;
      Messenger.off(eventName, handleUpdate);
    };
  }, [isExpired, eventName]);

  return status;
}

const csrf = csrfToken();
const headers = {
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
  ...csrf.header,
};

export function useSubmit(url, onSubmit, onError, method = 'PUT') {
  const handleSubmit = useCallback(() => {
    const fetchData = async () => {
      const response = await fetch(url, { method, headers });

      return response.ok
        ? await response.json()
        : await Promise.reject(response);
    };

    fetchData()
      .then((json) => onSubmit(json))
      .catch((error) => {
        if (error.json && onError) {
          error.json().then((e) => onError(e));
        }
      });
  }, [url, onSubmit, onError]);

  return handleSubmit;
}
